import { useEffect } from "react";
import { useSettings } from "@/context/SettingsContext";

export default function JivoInjector() {
  const { settings } = useSettings();
  const code = settings?.jivo_code;

  useEffect(() => {
    if (!code || document.getElementById("pp-jivo-marker")) return;
    try {
      document.body.appendChild(document.createRange().createContextualFragment(code));
      const marker = document.createElement("meta");
      marker.id = "pp-jivo-marker";
      document.head.appendChild(marker);
    } catch (e) {
      console.warn("jivo inject failed", e);
    }
  }, [code]);

  return null;
}
